import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
export function CTASection() {
  return <section className="px-6 py-10 max-w-4xl mx-auto text-center" data-id="element-28">
      <FadeIn data-id="element-29">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#4A5D3A] mb-8 leading-tight" data-id="element-30">
          SÍ — QUIERO APAGAR EL RUIDO MENTAL ESTA NOCHE
        </h2>

        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border border-[#4A5D3A]/10 max-w-2xl mx-auto" data-id="element-31">
          <CTAButton className="mb-8 py-6 text-xl md:text-2xl" data-id="element-32">
            QUIERO MI RESCATE BOTÁNICO POR $6.39 USD
          </CTAButton>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left text-sm md:text-base text-[#2D2A26]/80" data-id="element-33">
            <div className="flex items-center gap-3" data-id="element-34">
              <Lock className="text-[#4A5D3A] shrink-0" size={20} data-id="element-35" />
              <span data-id="element-36">
                <strong data-id="element-37">Pago 100% seguro</strong> procesado por Hotmart
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-38">
              <Zap className="text-[#C4A265] shrink-0" size={20} data-id="element-39" />
              <span data-id="element-40">
                <strong data-id="element-41">Acceso instantáneo</strong> — en menos de 2 minutos
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-42">
              <Shield className="text-[#4A5D3A] shrink-0" size={20} data-id="element-43" />
              <span data-id="element-44">
                <strong data-id="element-45">Garantía de 7 días</strong> — cero riesgo
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-46">
              <CreditCard className="text-[#9B4F2B] shrink-0" size={20} data-id="element-47" />
              <span data-id="element-48">
                <strong data-id="element-49">Solo $6.39 USD</strong> — menos que un café
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}